import SvgIcon from "@/components/SvgIcon";
import Vue from "vue";

// register globally
Vue.component("SvgIcon", SvgIcon);

const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const req = require.context("./svg", false, /\.svg$/);
requireAll(req);
